//****** CONFIGURACION PARA EJECUTAR EN PRODUCCION */

export const environment = {
  production: true,
  name: '(PROD)',
  APIEndpointPay: 'https://agendamiento.revisionestecnicas.cl/',
  //APIEndpointPay: 'https://agendamiento.revisionestecnicas.cl/',
  APIEndpoint: 'https://agendamiento.revisionestecnicas.cl', //dev
	googleAnalyticsId: 'G-8C7VCHCBGG',  
microservices: {
    auth: '/api/ms-prt-auth/',
    booking: '/api/ms-prt-booking-availability/',
    rules: '/api/ms-prt-booking-rules/',
    prebooking: '/api/ms-prt-booking-checkout/',
    savebooking: '/api/ms-prt-booking/',
    plant: '/api/ms-prt-plant-manager/',
    searchBooking: '/api/ms-prt-booking/',
    changeBooking: '/api/ms-prt-booking/',
    sendMail: '/api/ms-prt-booking/',
    payments: '/api/ms-prt-tax-document/',
    typesInspection: '/api/ms-prt-technical-inspection/',
    webpay: '/api/ms-sgs-payment/',
    channel: '/booking/search-type'
  },
  username: 'SGS',
  password: 'SGS',
  recaptcha: {
    siteKey: '6Lc5mjQjAAAAAMzqtnh30LwR4qLz49ysZw4uDIhI',
  }
};






//****** CONFIGURACION PARA EJECUTAR LOCALMENTE */

// export const environment = {
//   production: false,
//   name: '(DEV)',
//    APIEndpoint: 'http://localhost',
//   //APIEndpoint: 'https://agendamiento.revisionestecnicas.cl',
//   // APIEndpoint: 'https://uat-reservas.revisionestecnicas.cl',
//   microservices: {
//     auth: ':3000/',
//     booking: ':3004/',
//     rules: ':3002/',
//     prebooking: ':3005/',
//     savebooking: ':3001/',
//     plant: ':3008/',
//     searchBooking: ':3001/',
//     changeBooking: ':3001/',
//     sendMail: ':3001/',
//     payments: ':3011/',
//     typesInspection: ':3012/',
//     webpay: ':5213/',
//     channel: '/booking/search-type'
//   },
//   username: 'SGS',
//   password: 'SGS',
//   recaptcha: {
//     siteKey: '6Lc5mjQjAAAAAMzqtnh30LwR4qLz49ysZw4uDIhI',
//   }
// };